import { shippingLabelTemplateSchema } from "@redotech/redo-fulfillment-operations-common/shipping-label/shipping-label-template-definition";
import * as z from "zod";

export const getMerchantPrimaryShippingLabelTemplate = {
  name: "getMerchantPrimaryShippingLabelTemplate" as const,
  input: z.object({}),
  output: shippingLabelTemplateSchema.nullable(),
};
